import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const PageContainer = (props: Props) => {
    return (
        <div className="bg-utility-page w-full h-[calc(100vh-56px)] md:h-screen overflow-auto px-[12px] md:px-[30px]">
            {props.children}
        </div>
    )
}

export default PageContainer